import { takeLatest, put, call, all } from "redux-saga/effects";
import { ISaga } from "../types";
import { fetchInvestmentLandingPage } from "network/services/investmentServices";
import {
  fetchInvestementDataSuccess,
  fetchInvestmentDataFailed,
} from "../actionCreators";

function* fetchInvestmentPage(): ISaga {
  try {
    const { data: investementDataProducts } = yield call(
      fetchInvestmentLandingPage
    );

    yield put(fetchInvestementDataSuccess(investementDataProducts));
  } catch (e) {
    console.error("ERROR IN INVESTEMENT LANDING", e);
    yield put(fetchInvestmentDataFailed());
  }
}

export default function* () {
  yield takeLatest("FECTH_INVESTMENT_DATA", fetchInvestmentPage);
}
